module.exports = __webpack_public_path__ + "static/media/AI_19.664402b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_19.png
// module id = 134
// module chunks = 0